import { Row } from "react-bootstrap";
import {
  SiAmazonaws, SiMicrosoftazure, SiDocker, SiKubernetes, SiJenkins, SiAnsible,
  SiTerraform, SiGithubactions, SiPrometheus, SiGrafana, SiGitlab, SiNginx,
  SiPython, SiPostgresql, SiLinux,
} from "react-icons/si";

const stack = [
  { icon: <SiAmazonaws />,     label: "AWS" },
  { icon: <SiMicrosoftazure />,label: "Azure" },
  { icon: <SiDocker />,        label: "Docker" },
  { icon: <SiKubernetes />,    label: "Kubernetes" },
  { icon: <SiTerraform />,     label: "Terraform" },
  { icon: <SiAnsible />,       label: "Ansible" },
  { icon: <SiJenkins />,       label: "Jenkins" },
  { icon: <SiGitlab />,        label: "GitLab" },
  { icon: <SiGithubactions />, label: "GitHub Actions" },
  { icon: <SiPrometheus />,    label: "Prometheus" },
  { icon: <SiGrafana />,       label: "Grafana" },
  { icon: <SiNginx />,         label: "Nginx" },
  { icon: <SiPython />,        label: "Python" },
  { icon: <SiPostgresql />,    label: "PostgreSQL" },
  { icon: <SiLinux />,         label: "Linux" },
];

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "40px", flexWrap: "wrap" }}>
      {stack.map((item) => (
        <div key={item.label} className="tech-icons">
          {item.icon}
          <span className="tech-icon-label">{item.label}</span>
        </div>
      ))}
    </Row>
  );
}

export default Techstack;
